export default __webpack_public_path__ + "static/media/kuchnia12.f3631382.jpg";